import React, { useEffect, useState } from "react";
import Meta from "../../components/Meta";
import fetchCollections from "../../services/fetchCollections";
import ImageTitle from "../../components/imageTitle";
import { GlobalOfferModal } from "../../components/modal/globalOfferModal";
import { AvailableToLend } from "../../components/lend/availableToLend";
import { Tab, Tabs } from "@mui/material";
import { CustomTabPanel } from "../../components/customTabPanel";
import { ListGlobalOffers } from "../../components/lend/listGlobalOffers";

const CustomTab = ({ label, ...props }) => {
  return (
    <Tab
      {...props}
      label={label}
      className="font-display text-[0.7rem] normal-case sm:text-2xs md:text-base"
      classes={{
        textColorPrimary: "text-jacarta-700 dark:text-white",
        selected: "!text-accent",
      }}
      disableRipple
    />
  );
};

const Lend = () => {
  const [tab, setTab] = useState(0);
  const [collections, setCollections] = useState<any[]>([]);
  const [selectedCollections, setSelectedCollections] = useState<any[]>([]);
  const [globalOfferModalOpen, setGlobalOfferModalOpen] = useState(false);
  const [selectedCollectionInModal, setSelectedCollectionInModal] =
    useState<any>(null);

  const handleChange = (e: any, value: any) => {
    setTab(value);
  };

  const getCollections = async () => {
    const coll: any[] = await fetchCollections({});
    setCollections(coll);
    setSelectedCollectionInModal(coll[0]);
  };

  useEffect(() => {
    getCollections();
    return () => {};
  }, []);

  return (
    <div className="mt-28">
      <Meta title="Bit5 Lending | Lend" />
      <ImageTitle
        text="Lend"
        image={"/images/lending-lend.png"}
        input={undefined}
      />

      <section className="relative py-24">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          <img
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full"
          />
        </picture>
        <div className="container ">
          <Tabs
            value={tab}
            onChange={handleChange}
            aria-label="tabs"
            classes={{
              root: "justify-center",
              scroller: "grow-0",
              indicator: "bg-accent",
              flexContainer:
                "flex items-center justify-center gap-x-0 sm:gap-x-3 lg:gap-x-4",
            }}
            allowScrollButtonsMobile
            variant="scrollable"
          >
            <CustomTab label="Available To Lend" id={0} />
            <CustomTab label="Global Offers" id={1} />
          </Tabs>
          <div className="grid grid-cols-12 space-y-8 md:space-x-8">
            <div className="col-span-12 md:col-span-3">
              <h2 className="font-display text-jacarta-700 py-4 text-2xl font-medium dark:text-white">
                Filters
              </h2>

              <div className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2lg border bg-white p-4 divide-y divide-jacarta-600 ">
                <div>
                  <h4 className="font-display text-jacarta-700 pt-4 mb-2 text-lg font-medium dark:text-white">
                    Collections
                  </h4>

                  <div className="">
                    {collections &&
                      collections
                        .filter((c) =>
                          tab === 0
                            ? !!c?._count?.lendOrders
                            : !!c?._count?.lendOffers
                        )
                        .sort((a, b) => {
                          if (tab === 0) {
                            if (a?._count?.lendOrders > b?._count?.lendOrders) {
                              return -1;
                            }
                            if (a?._count?.lendOrders < b?._count?.lendOrders) {
                              return 1;
                            }
                          } else {
                            if (a?._count?.lendOffers > b?._count?.lendOffers) {
                              return -1;
                            }
                            if (a?._count?.lendOffers < b?._count?.lendOffers) {
                              return 1;
                            }
                          }
                          return 0;
                        })
                        .map((collection, i) => {
                          return (
                            <div
                              key={i}
                              className="flex justify-between my-4 items-center"
                            >
                              <div className="">
                                <label className="dark:text-jacarta-200">
                                  {collection.name}{" "}
                                  {tab === 0
                                    ? collection?._count?.lendOrders
                                      ? `(${collection?._count?.lendOrders})`
                                      : ""
                                    : collection?._count?.lendOffers
                                    ? `(${collection?._count?.lendOffers})`
                                    : ""}
                                </label>
                              </div>

                              <div className="2">
                                <input
                                  checked={selectedCollections.includes(
                                    collection
                                  )}
                                  onChange={() => {
                                    // setTermsAccepted(!termsAccepted)
                                    if (
                                      selectedCollections.includes(collection)
                                    ) {
                                      setSelectedCollections(
                                        selectedCollections.filter(
                                          (coll) => collection.id !== coll.id
                                        )
                                      );
                                    } else {
                                      setSelectedCollections([
                                        ...selectedCollections,
                                        collections.find(
                                          (coll) => collection.id === coll.id
                                        ),
                                      ]);
                                    }
                                  }}
                                  type="checkbox"
                                  className="checked:bg-accent dark:bg-jacarta-600 text-accent border-jacarta-200 focus:ring-accent/20 dark:border-jacarta-500 h-6 w-6 self-start rounded focus:ring-offset-0 cursor-pointer"
                                />
                              </div>
                            </div>
                          );
                        })}
                  </div>
                </div>
              </div>
            </div>
            <CustomTabPanel
              value={tab}
              index={0}
              className="col-span-12 md:col-span-9"
            >
              <AvailableToLend
                selectedCollections={selectedCollections}
                setGlobalOfferModalOpen={setGlobalOfferModalOpen}
                key={"available-to-lend"}
              />
            </CustomTabPanel>
            <CustomTabPanel
              value={tab}
              index={1}
              className="col-span-12 md:col-span-9"
            >
              <ListGlobalOffers
                selectedCollections={selectedCollections}
                setGlobalOfferModalOpen={setGlobalOfferModalOpen}
                key={"global-offers"}
              />
            </CustomTabPanel>
          </div>
        </div>
      </section>
      <GlobalOfferModal
        globalOfferModalOpen={globalOfferModalOpen}
        setGlobalOfferModalOpen={setGlobalOfferModalOpen}
        collections={collections}
        selectedCollectionInModal={selectedCollectionInModal}
        setSelectedCollectionInModal={setSelectedCollectionInModal}
      />
    </div>
  );
};

export default Lend;
